import React from "react";
import { BUILD_VERSAO, BUILD_DATA_ISO, EH_BUILD_PUBLICADA, formatarDataBuild } from "../buildInfo";

/**
 * Rodapé discreto com a identificação da build em produção.
 *
 * Serve para conferir a olho nu se um deploy entrou no ar: a versão é o commit
 * publicado e a data/hora é o momento do build.
 */
const VersaoBuild = () => {
    const dataFormatada = formatarDataBuild();

    // Título com o detalhe completo, para quando o resumo não bastar.
    const detalhe = EH_BUILD_PUBLICADA
        ? `Commit ${BUILD_VERSAO} · build de ${BUILD_DATA_ISO || "data não registrada"}`
        : "Build de desenvolvimento (servida pelo npm start, não publicada)";

    return (
        <div
            title={detalhe}
            className="px-2 sm:px-6 pb-2 text-right text-[11px] leading-tight text-slate-400 select-text"
        >
            <span className="font-mono">{BUILD_VERSAO}</span>
            {dataFormatada && <span> · {dataFormatada}</span>}
        </div>
    );
};

export default VersaoBuild;
